import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import {
  Assessment, Security, LocalFireDepartment, Bolt, TrendingUp, Speed,
} from '@mui/icons-material';
import { Tile } from './primitives';
import { TileSkeleton } from './skeletons';
import { fmtScore } from './helpers';

// ═══════════════════════════════════════════════════════════════════════════

const StatTilesBlock = ({ isFirstLoad, data, summary, T }) => (
      isFirstLoad ? (
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(3, 1fr)', md: 'repeat(6, 1fr)' }, gap: 1.5, mb: 2.5 }}>
          {[0, 1, 2, 3, 4, 5].map(i => <TileSkeleton key={i} />)}
        </Box>
      ) : data && (
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(3, 1fr)', md: 'repeat(6, 1fr)' }, gap: 1.5, mb: 2.5 }}>
          <Tile label={T('tiles.totalScanned')} value={data.total_scanned || 0} sub={T('tiles.stocksScanned')} color="#64748b" Icon={Assessment} />
          <Tile label={T('tiles.silentAccum')} value={data.total_silent_accum || 0} sub={T('tiles.candidates')} color="#8b5cf6" Icon={Security} />
          <Tile label={T('tiles.breakImminent')} value={summary.break_imminent || 0} sub={T('tiles.aboutToBreak')} color="#ef4444" Icon={LocalFireDepartment} />
          <Tile label={T('tiles.breakReady')} value={summary.break_ready || 0} sub={T('tiles.readyLabel')} color="#f59e0b" Icon={Bolt} />
          <Tile label={T('tiles.avgAccum')} value={fmtScore(summary.avg_accum_score)} sub={T('tiles.average')} color="#3b82f6" Icon={TrendingUp} />
          <Tile label={T('tiles.avgBreakReady')} value={fmtScore(summary.avg_break_readiness)} sub={T('tiles.average')} color="#10b981" Icon={Speed} />
        </Box>
      )
);
StatTilesBlock.propTypes = {
  isFirstLoad: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  summary: PropTypes.object,
  T: PropTypes.func,
};

export default StatTilesBlock;
